/*
 *
 *  remotes
 *
 */

import api from "../../helpers/Api"
import constantName from "./key"

export function loadRecords() {
  console.log("constantName-->", constantName)
  let payload = {"status": "both"}
  return api
    .post(`/get_all_hrms_policy_setting`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, params = {}) {
  if (method === "post") {
    return api
      .post(`/get_all_${metaData}`, params)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  } else {
    return api
      .get(`/get_all_${metaData}`, params)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error))
  }
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function loadRecord(id) {
  return api
    .get(`/get_hrms_policy_setting_by_id?${atob(constantName)}Id=${id}`, {status: "both"})
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function createRecord(record) {
  if (record) {
    if (record.slCarry === "No") {
      record.slBundle = "0"
      record.cl = "0"
    }
    if (record.clCarry === "No") {
      record.clBundle = "0"
      record.permissionPerMonth = "0"
    }
  }
  return api
    .post(`/add_hrms_policy_setting`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateRecord(record) {
  if (record) {
    if (record.slCarry === "No") {
      record.slBundle = "0"
      record.cl = "0"
    }
    if (record.clCarry === "No") {
      record.clBundle = "0"
      record.permissionPerMonth = "0"
    }
  }
  return api
    .put(`/update_hrms_policy_setting_by_id`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {integer} id
 * @returns
 */
export function deleteRecord(id) {
  return api
    .put(`/delete_hrms_policy_setting_by_id`, {
      [`hrmsPolicySettingId`]: [id],
      status: 3,
    })
    .catch((error) => Promise.reject(error))
}

/**
 *
 * @param {object} record
 * @returns
 */
export function updateStatus(record) {
  return api
    .put(`/delete_hrms_policy_setting_by_id`, record)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  loadRecords,
  loadRecordsMetaData,
  loadRecord,
  createRecord,
  updateRecord,
  deleteRecord,
  updateStatus,
}

export default remotes
